import React from 'react';
import styled from 'styled-components';

const FlikingArrow = ({ preArrow, nextArrow }) => {
  const prevBtn = () => {
    if (preArrow.current) {
      preArrow.current.click();
    }
  };

  const nextBtn = () => {
    if (nextArrow.current) {
      nextArrow.current.click();
    }
  };

  return (
    <FilkingArrow>
      <button onClick={prevBtn}>〈</button>
      <button onClick={nextBtn}>〉</button>
    </FilkingArrow>
  );
};

export default FlikingArrow;

const FilkingArrow = styled.div`
  & button {
    color: ${props => props.theme.subText};
    cursor: pointer;
    width: 20px;
    height: 17px;
  }
`;
